import React, { useEffect } from 'react';
import { useAuthStore } from '../../context/AuthContext';
import useGetPBIAccessToken from '../../api/useGetPBIAccessToken';
import { getDiffBetweenDates } from 'odfjell-date-time-utils/dateTimeUtils';
import { PbiToken } from '../../types/PbiTypes';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { MainButton } from 'src/styles/button.style';
import { Label } from 'src/components/page-header/HeaderItem.styles';
import { SectionMenuWrapper, Wrapper } from './PBIReport.styles';
import { usePbiReportPagesStore } from 'src/context/PbiReportsContext';
import PBIReport from './PBIReport';

const PBIReportWrapper: React.FC = () => {
    const { pbiAuthorization } = useAuthStore();
    const { getPbiAccessToken } = useGetPBIAccessToken();
    const { getQueryParamValueFromUrl, triggerQueryParamsUpdate } = useQueryParamsHandler();
    const { reportPages, selectedReport, setSelectedReport } = usePbiReportPagesStore();

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const reportName = queryParams.get('reportName');
        checkToken();
        setSelectedReport(reportName);
    }, [window.location.search]);

    useEffect(() => {
        checkToken();
    }, []);

    const checkToken = () => {
        if (!pbiAuthorization) {
            getAccessToken();
            return false;
        } else {
            try {
                const tokenPayload = pbiAuthorization?.token.split('.')?.[1];
                const token = JSON.parse(atob(tokenPayload)) as PbiToken;
                const expiry = new Date(token.exp * 1000);

                const timeToExpiry = getDiffBetweenDates(expiry, new Date(), 'minute').minutes;

                if (timeToExpiry > 10) {
                    return true;
                } else {
                    getAccessToken();
                    return false;
                }
            } catch {
                getAccessToken();
                return false;
            }
        }
    };

    const getAccessToken = () => {
        getPbiAccessToken();
    };

    const changeSection = (sectionName: string) => {
        const imoNumber = getQueryParamValueFromUrl('imoNumber');
        const dashboard = getQueryParamValueFromUrl('dashboard');
        const appAccessToken = getQueryParamValueFromUrl('appAccessToken');
        const reportName = getQueryParamValueFromUrl('reportName');
        const newParams = [
            { name: 'imoNumber', newValue: imoNumber },
            { name: 'dashboard', newValue: dashboard },
            { name: 'reportName', newValue: reportName },
            { name: 'reportSection', newValue: sectionName },
        ];
        if (appAccessToken) newParams.push({ name: 'appAccessToken', newValue: appAccessToken });

        triggerQueryParamsUpdate(newParams, 'clear-all');
    };

    return (
        <Wrapper>
            {reportPages && reportPages.length > 1 && (
                <SectionMenuWrapper>
                    {reportPages?.map((s) => (
                        <MainButton
                            style={{ width: '100%', minHeight: '40px' }}
                            key={s.name}
                            onClick={() => changeSection(s.name)}
                            isSelected={s.isActive}
                        >
                            <Label>{s.displayName}</Label>
                        </MainButton>
                    ))}
                </SectionMenuWrapper>
            )}
            <div style={{ width: '100%' }}>
                <PBIReport selectedReport={selectedReport} selectedSection={getQueryParamValueFromUrl('reportSection')} checkToken={checkToken} />
            </div>
        </Wrapper>
    );
};

export default PBIReportWrapper;
